import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { documentTypeLabels, formatDateTime, lineStatusLabels } from '../../../helpers/logisticaHelper'
import {
    StyledTable,
    StyledHeaderCell,
    StyledBodyCell,
    StyledBodyRow,
    EmptyState,
} from '../../../ui/StyledComponents'

// Líneas que dejaron de estar vigentes: editadas (Replaced), quitadas (Removed) o de una planilla anulada (Cancelled).
// Solo lectura: muestran cómo estaba la línea y quién la cambió.
export default function HistorialLineas({ lineas }) {
    return (
        <Accordion disableGutters sx={{ mt: 3 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle2">Historial de cambios ({lineas.length})</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <TableContainer sx={{ maxHeight: { xs: 300, md: '40vh' }, overflow: 'auto' }}>
                    <StyledTable size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledHeaderCell align="center">Estado</StyledHeaderCell>
                                <StyledHeaderCell align="center">Tipo</StyledHeaderCell>
                                <StyledHeaderCell align="center">N° Documento</StyledHeaderCell>
                                <StyledHeaderCell align="center">Cliente</StyledHeaderCell>
                                <StyledHeaderCell align="center">Dirección Entrega</StyledHeaderCell>
                                <StyledHeaderCell align="center">Bultos</StyledHeaderCell>
                                <StyledHeaderCell align="center">Agregada</StyledHeaderCell>
                                <StyledHeaderCell align="center">Cambio</StyledHeaderCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lineas.length > 0 ? (
                                lineas.map((linea) => (
                                    <StyledBodyRow key={linea.lineId}>
                                        <StyledBodyCell align="center">{lineStatusLabels[linea.status] ?? linea.status}</StyledBodyCell>
                                        <StyledBodyCell align="center">{documentTypeLabels[linea.documentType] ?? linea.documentType}</StyledBodyCell>
                                        <StyledBodyCell align="center">{linea.documentNumber}</StyledBodyCell>
                                        <StyledBodyCell align="left">{linea.customerName}</StyledBodyCell>
                                        <StyledBodyCell align="left">{linea.deliveryAddress}</StyledBodyCell>
                                        <StyledBodyCell align="center">{linea.packages}</StyledBodyCell>
                                        <StyledBodyCell align="center">{linea.addedBy} {formatDateTime(linea.addedDate)}</StyledBodyCell>
                                        <StyledBodyCell align="center">{linea.statusChangedBy} {formatDateTime(linea.statusChangedDate)}</StyledBodyCell>
                                    </StyledBodyRow>
                                ))
                            ) : (
                                <TableRow>
                                    <StyledBodyCell colSpan={8}>
                                        <EmptyState>La planilla no tiene cambios.</EmptyState>
                                    </StyledBodyCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </AccordionDetails>
        </Accordion>
    )
}
